import { Text } from 'src/Components'
import styles from './Label.module.scss'

export interface LabelProps {
  children: React.ReactNode
}

export const Label = ({ children }: LabelProps) => (
  <Text
    size='s'
    className={styles.label}
    element='div'
    variant='neutralWarm'
    variantCount='500'
    weight='bold'
    transform='uppercase'
    letterSpacing='10'
  >
    {children}
  </Text>
)
